import { importAll, transformImages } from "utils";

import Gallery from "components/Media/Gallery";
import { Link } from "react-router-dom";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import backgroundImage from "./gallery/promo-muggle-murders-rise_02.jpg";
import quibbler from "assets/replicas/harry-potter/hp-quibbler/hp-quibbler-hp7-muggle-murders-rise";
import quibblerV1 from "assets/replicas/harry-potter/hp-quibbler/hp-quibbler-hp7-muggle-murders-rise/v1";
import { routes } from "config";

let gallery = [];
try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/),
  );
} catch (e) {
  console.warn(e);
}

const background = {
  src: backgroundImage,
  opacity: 0.1,
};

const Page = () => {
  const galleryImages = transformImages(gallery);

  return (
    <ReplicaContent>
      <ReplicaParagraph>
        This is a Grade-B replica of{" "}
        <Link
          to={`/${routes.replicaDetailVersion.slug.replace(":id", quibbler.id).replace(":version", `v${quibblerV1.version}`)}`}
          target="_blank"
        >
          The Quibbler v1 – Muggle Murders Rise
        </Link>
        . The replica is 1:1 with the final version, with the only difference
        being the type of paper used. While very similar to the material used in
        the final replica, I later decided to replace it with a better
        alternative, resulting in slightly different color grading and a much
        better "feel" when handled. The visual difference is negligible in
        practice, however, and the replica is otherwise identical to the final
        prop from the outside and the inside. It is graded as "B" only because
        it was created before this material change was made and thus doesn't fit
        the final look I was aiming for.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <Gallery
        images={galleryImages}
        imagesPerRow={3}
        aspectRatio={1}
        imageMaxHeight="240px"
        imageOptions={[
          { index: 1, aspectRatio: 0.7 },
          { index: 2, aspectRatio: 1.3 },
        ]}
      />
      <ReplicaSpacer />
    </ReplicaContent>
  );
};

export default Page;
export { background };
